import { useIntl } from "react-intl";

import messages from "./messages";

const useStepTitle = (leadsCount: number) => {
  const intl = useIntl();

  return intl.formatMessage(messages.title, { count: leadsCount });
};

export default useStepTitle;
